import { DateTime } from 'luxon';
import * as yup from 'yup';

export const notFutureDate = (message = 'Date cannot be in the future') =>
  yup.string().test('not-future-date', message, (value) => {
    if (!value) return true;

    const selectedDate = DateTime.fromISO(value, { zone: 'utc' });
    const today = DateTime.utc();

    return selectedDate <= today;
  });
